import { ITire } from 'app/shared/model/tire.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';

export interface ITireTruckImplement {
  id?: number | null;
  installVehicleOdometer?: number | null;
  installTireOdometer?: number | null;
  installOdometer?: number | null;
  position?: number | null;
  steppe?: boolean | null;
  tire?: ITire | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<ITireTruckImplement> = {
  steppe: false,
};
